import checkmark from './checkmark.svg?raw';
import chevronDown from './chevron-down.svg?raw';
import chevronLeft from './chevron-left.svg?raw';
import chevronRight from './chevron-right.svg?raw';
import chevronUp from './chevron-up.svg?raw';
import close from './close.svg?raw';
import info from './info.svg?raw';
import lifebuoy from './lifebuoy.svg?raw';
import logo from './logo.svg?raw';
import quote from './quote.svg?raw';
import voucherSmall from './voucher-small.svg?raw';
import pdf from './pdf.svg?raw';
import voucher from './voucher.svg?raw';
import voucherWhite from './voucher-white.svg?raw';
import quoteSmall from './quote-small.svg?raw';
import priceCampaign from './price-campaign.svg?raw';
import priceCampaignSmall from './price-campaign-small.svg?raw';
import startInsurance from './start-insurance.svg?raw';
import circleBackground from './circle-background.svg?raw';
import circleBackground1 from './circle-background1.svg?raw';
import kidsThree from './kidsThree.svg?raw';
import kidsFour from './kidsFour.svg?raw';
import kidsFive from './kidsFive.svg?raw';
import euMap from './map-eu.svg?raw';
import worldMap from './map-world.svg?raw';
import popupIllustration from './popup-illustration.svg?raw';
import vaccine from './vaccine.svg?raw';
import add from './add.svg?raw';
import arrowLeft from './arrow-left.svg?raw';
import arrowRight from './arrow-right.svg?raw';
import phone from './phone.svg?raw';
import heart from './heart.svg?raw';
import mitId from './mitId.svg?raw';
import searchIcon from './searchIcon.svg?raw';
import tickmark from './tickmark.svg?raw';
import check from './check.svg?raw';
import chevronDownRed from './chevron-down-red.svg?raw';
import toggle from './toggle.svg?raw';
import toggleWhite from './toggle-white.svg?raw';
import whiteCheckmarkIcon from './white-Checkmark-Icon.svg?raw';

const icons = {
  checkmark,
  whiteCheckmarkIcon,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  close,
  info,
  lifebuoy,
  logo,
  quote,
  voucherSmall,
  pdf,
  voucher,
  voucherWhite,
  quoteSmall,
  priceCampaign,
  priceCampaignSmall,
  startInsurance,
  circleBackground,
  circleBackground1,
  kidsThree,
  kidsFour,
  kidsFive,
  euMap,
  worldMap,
  popupIllustration,
  vaccine,
  add,
  arrowLeft,
  arrowRight,
  phone,
  heart,
  mitId,
  searchIcon,
  tickmark,
  check,
  chevronDownRed,
  toggle,
  toggleWhite
};

export default icons;
